import React from "react";
// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import TextField from "@limitless/modern/inputs/text-field/TextField";
import Button from "@limitless/modern/inputs/button/Button";
import AnimationWrapper from "@limitless/modern/components/animation-wrapper/AnimationWrapper";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import { AddressForm, useExpertProfileContext } from "@limitless/expert";
import { useResources } from "@limitless/common/hooks";
import { findSuggestionFromList } from "@limitless/portal";
import SuccessAnimation from "@limitless/modern/components/success-animation/SuccessAnimation";
import ContactSupport from "@limitless/portal/components/header/manager-settings-screen/tabs-content/ContactSupport";

const Address = () => {
    const [isSuccess, setIsSuccess] = React.useState(false);
    const [showAnimation, setShowAnimation] = React.useState(false);
    const { isEditable } = useExpertProfileContext();
    const {
        resources: {
            towns: { towns }
        }
    } = useResources();

    const handleSaveClick = onFormSubmit => {
        onFormSubmit();
        setIsSuccess(true);
        setTimeout(() => {
            setIsSuccess(false);
            setShowAnimation(true);
        }, 4000);
    };

    const renderTownsField = (town, fieldErrors, onAddressChange) => {
        if (towns?.length > 0) {
            return (
                <DropdownMenu
                    label="Town / City"
                    required
                    disabled={isEditable}
                    id="townAddressInputField"
                    value={towns && town.value ? findSuggestionFromList(towns, { value: town.value }) : null}
                    options={towns}
                    onChange={(e, town) => onAddressChange("town", town.value)}
                    textFieldProps={{
                        error: fieldErrors.town && fieldErrors.town !== "",
                        helperText: fieldErrors.town
                    }}
                />
            );
        }

        return (
            <TextField
                name="town"
                label="Town / City"
                placeholder="Type town / city"
                id="townOrCityAddressInputField"
                onChange={event => onAddressChange("town", event.target.value)}
                value={town.value}
                disabled={isEditable}
                required
                error={fieldErrors.town && fieldErrors.town !== ""}
                errorText={fieldErrors.town}
            />
        );
    };

    return (
        <AddressForm>
            {({ address1, address2, town, postalCode, fieldErrors, isFormInvalid, onAddressChange, onFormSubmit }) => {
                return (
                    <AnimationWrapper showAnimation>
                        <Grid sx={{ maxWidth: "600px" }}>
                            {isEditable && <ContactSupport />}
                            <Grid mt={theme => theme.spacing(3)}>
                                <TextField
                                    label="Address line 1"
                                    required
                                    id="address1AddressInputField"
                                    disabled={isEditable}
                                    onChange={event => onAddressChange("address1", event.target.value)}
                                    value={address1.value}
                                    error={fieldErrors.address1 && fieldErrors.address1 !== ""}
                                    errorText={fieldErrors.address1}
                                />
                            </Grid>
                            <Grid mt={theme => theme.spacing(3)}>
                                <TextField
                                    label="Address line 2"
                                    id="address2AddressInputField"
                                    value={address2.value}
                                    disabled={isEditable}
                                    onChange={event => onAddressChange("address2", event.target.value)}
                                    error={fieldErrors.address2 && fieldErrors.address2 !== ""}
                                    errorText={fieldErrors.address2}
                                />
                            </Grid>
                            <Grid mt={theme => theme.spacing(3)} item xs={6}>
                                {renderTownsField(town, fieldErrors, onAddressChange)}
                            </Grid>
                            <Grid mt={theme => theme.spacing(3)} item xs={6}>
                                <TextField
                                    label="Postal code"
                                    required
                                    id="postalCodeAddressInputField"
                                    value={postalCode.value}
                                    disabled={isEditable}
                                    onChange={event => onAddressChange("postalCode", event.target.value)}
                                    error={fieldErrors.postalCode && fieldErrors.postalCode !== ""}
                                    errorText={fieldErrors.postalCode}
                                />
                            </Grid>
                            <Grid mt={theme => theme.spacing(3)} mb={theme => theme.spacing(3)}>
                                {!isSuccess ? (
                                    <AnimationWrapper showAnimation={showAnimation}>
                                        <Button
                                            variant="contained"
                                            disabled={isFormInvalid}
                                            onClick={() => handleSaveClick(onFormSubmit)}
                                            id="saveAddressChangesButton"
                                        >
                                            Save Changes
                                        </Button>
                                    </AnimationWrapper>
                                ) : (
                                    <SuccessAnimation />
                                )}
                            </Grid>
                        </Grid>
                    </AnimationWrapper>
                );
            }}
        </AddressForm>
    );
};

export default Address;
